export default __webpack_public_path__ + "static/media/burningMoney.45ec76f4.svg";